import React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiTile, StatusPill } from '../patterns';
import type { NutritionSummary } from '../../services/nutritionService';
import { formatDate } from '../../dateFormat';

export const NutritionKpiRow: React.FC<{ summary: NutritionSummary }> = ({ summary }) => {
  const { t } = useTranslation();
  const a = summary.appliedThisMonth;
  return (
    <div className="pat-kpi-row">
      {/*
        #443: the "Foliar and soil" scope pill belongs to THIS tile only —
        appliedThisMonth is written by both stacks, but the neighbouring
        "Foliar windows open" tile is foliar-only. It used to sit in a bare
        div after the whole row, where it read as a row-level label and was
        therefore wrong for that neighbour.
      */}
      <KpiTile
        primary
        label={t('nutrition.dashboard.kpi.appliedThisMonth')}
        value={a.orchards}
        delta={(
          <span className="ntr-dash-kpi-delta">
            <span>{t('nutrition.dashboard.kpi.appliedThisMonthDelta', { n: a.n, p: a.p, k: a.k })}</span>
            <span data-testid="nutrition-scope-applied">
              <StatusPill variant="info">{t('nutrition.dashboard.scopeBoth')}</StatusPill>
            </span>
          </span>
        )}
      />
      <KpiTile
        label={t('nutrition.dashboard.kpi.foliarOpen')}
        value={summary.foliarWindowsOpen}
        delta={t('nutrition.dashboard.kpi.foliarOpenDelta')}
      />
      {summary.inventory && (
        <KpiTile
          alert={(summary.inventory.stockCover ?? 100) < 100}
          label={t('nutrition.dashboard.kpi.stockCover')}
          value={summary.inventory.stockCover == null ? '—' : `${summary.inventory.stockCover}%`}
          delta={t('nutrition.dashboard.kpi.stockCoverDelta', { date: summary.inventory.orderBy ? formatDate(summary.inventory.orderBy) : '—' })}
        />
      )}
      <KpiTile
        label={t('nutrition.dashboard.kpi.signoffsOutstanding')}
        value={summary.signoffsOutstanding.count}
        delta={t('nutrition.dashboard.kpi.signoffsOutstandingDelta')}
      />
    </div>
  );
};

export default NutritionKpiRow;
